/*
 * @Description: 
 * @Author: 时生
 * @Date: 2020-04-17 16:25:05
 * @LastEditTime: 2020-12-24 15:29:21
 * @LastEditors: xutao
 */
// 数据仓库
import Vue from 'vue'
import Vuex from 'vuex'
import YunJi from '@/common/js/YunJi'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    stateHeight: '20px',
    headerHeight: '64px',
    appCont: YunJi.getUrlParams('appCont') || 0,
    shopId: Number(YunJi.getUrlParams('shopId')) || 968,
    smsId: YunJi.getUrlParams('smsId'),
    clientWidth: document.body.clientWidth || window.screen.width || window.screen.availWidth,
    isApp: YunJi.isApp(),
    isIhponeX: YunJi.isIphoneXall(),
    isFromHeJi: YunJi.getUrlParams('isFromHeJi') || 0,
    // 和计那边的活动id
    activityId: YunJi.getUrlParams('activityId'),
    // 福袋code
    luckBagCode: YunJi.getUrlParams('luckBagCode')
  },
  mutations: {    

  },
  getters: {
    appCont(state) {
      return state.appCont
    },
    shopId(state) {
      return state.shopId
    },
    isFromHeJi(state) {
      return state.isFromHeJi
    },
    activityId(state) {
      return state.activityId
    },
    luckBagCode(state) {
      return state.luckBagCode
    },
    smsId(state) {
      return state.smsId
    }
  }
})
